import {
    STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getVersionsDataMaster(brandId, modelId, year) {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_BEGIN,
        data: {brandId, modelId, year}
      })
    }
  }